import {Component, EventEmitter, Input, input, Output, ChangeDetectionStrategy} from '@angular/core';
import {WaButtonDirective, WaIconDirective} from "angular-awesome";
import {StaffMember} from "../../../../api/models/staff-member";

@Component({
  selector: 'app-supervision-staff-member',
    imports: [
        WaButtonDirective,
        WaIconDirective
    ],
  templateUrl: './supervision-staff-member.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './supervision-staff-member.component.scss',
})
export class SupervisionStaffMemberComponent {

  staffmember = input.required<StaffMember>();
  @Output() fix = new EventEmitter<StaffMember>();
  @Output() exclude = new EventEmitter<StaffMember>();

}
